/**
 * Timestamp of when the module bootstrap starts
 * Unlike a full page reload, where we use timing.navigationStart, in place module switch
 * we need to explicitly set the navigation start time.
 */
let navigationStart: number = null;

export const setNavigationStart = (time: number) => {
    navigationStart = time;
};

export const resetNavigationStart = () => {
    navigationStart = null;
};

/**
 * Returns time from Fetch start.
 * Required for the purpose of measuring key metrics from the time page fetch starts.
 */
export function getTimeFromFetchStart(timeMeasured?: number): number {
    const currentTime = timeMeasured ?? performance.now();

    // Ignore zero values due to browser timing API limitations
    if (currentTime === 0) {
        return currentTime;
    }

    let offset: number;
    if (navigationStart) {
        offset = navigationStart;
    } else {
        offset =
            window.performance?.timing?.fetchStart - window.performance?.timing.navigationStart;
    }

    if (!offset) {
        /**
         * The performance timing should always be there but just in case not present,
         * then diff can be marked as 0 to avoid returning NaN.
         */
        offset = 0;
    }

    return currentTime - offset;
}
